import axios from "axios"
import { showToastAction } from "../redux/toastSlice";
export default async function getResearchKeys(projectName, formName) {
    try {
        return await axios.get(`/project/${projectName}/${formName}/research-document-validated`);
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}